export default {
  title: 'צפייה בפרטי הסוכן {1}',
  titleEdit: 'עריכת פרטי הסוכן {1}',
  subtitle: 'עודכן לאחרונה בתאריך {1}',
  action: 'ערוך סוכן',
  menu: {
    details: 'פרטים',
    contracts: 'הסכמים',
    documents: 'מסמכים',
    clients: 'תיקים',
    alternativeFunds: 'קרנות אלטרנטיביות',
    expenses: 'חיוב הסוכן',
    emails: 'מיילים',
    commisions: 'עמלות',
    additionalfees: 'תשלומים +',
  },
  status: {
    active: 'פעיל',
    archive: 'ארכיון',
  },
  side: {
    tabs: 'מידע נוסף',
    comments: 'הערות',
    histories: 'היסטוריה',
  },
  labels: {
    commision: {
      agentFeeMonthlyDeposit: 'עמלת סוכן נפרעים מהפקדה',
      agentFeeMonthlyAccumulation: 'עמלת סוכן נפרעים מצבירה',
      agentFeeAnnualAccumulation: 'עמלת סוכן היקף מצבירה',
      agentFeeAnnualDeposit: 'עמלת סוכן היקף מהפקדה',
    },
  },
  headers: {
    history: 'היסטוריה',
    comment: 'הערות',
    contracts: 'הסכמים',
    extra: 'מידע נוסף',
  },
};
